"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRADE_CHANGED_LEVERAGED_HAS_ACTIVE_ORDERS = exports.TRADE_CHANGED_LEVERAGED_HIGH_POSITION_VALUE = exports.TRADE_CHANGED_LEVERAGED_LOW_MARGIN = exports.TRADE_NOT_HAVE_LEVERAGED_CONFIG = exports.TRADE_LEVERAGED_ACCOUNT_LIMIT = exports.TRADE_LEVERAGED_TOTAL_QUOTA = exports.TRADE_SYMBOL_INFO_NONE = exports.TRADE_TRIGGER_PRICE_NONE = exports.TRADE_NOTIONAL_NEED_LOWER_LEVERAGE_ROW = exports.TRADE_NO_LEVERAGE_ROW = exports.TRADE_LIMIT_POST_PRICE_LOW = exports.TRADE_LIMIT_POST_PRICE_HIGH = exports.TRADE_DISABLE_OF_LIQUIDATION = exports.TRADE_INVEST_MORE_THAN_CAN_BUY = exports.TRADE_AVAILABLE_NOT_ENOUGH = exports.TRADE_NO_AVAILABLE = exports.TRADE_LIMIT_PRICE_LOW = exports.TRADE_LIMIT_PRICE_HIGH = exports.TRADE_COST_HIGH_THAN_MAX = exports.TRADE_COST_LOW_THAN_MIN = exports.TRADE_QTY_HIGH_THAN_MAX = exports.TRADE_QTY_LOW_THAN_MIN = exports.TRADE_DISABLE_INVEST_QUOTE_ON_LIMIT = exports.TRADE_NO_INVEST = exports.TRADE_NO_LIMIT_PRICE = exports.TRADE_NO_CURRENT_PRICE = void 0;
exports.TRADE_NO_CURRENT_PRICE = { code: "0025000000", message: "local: current price is null" };
exports.TRADE_NO_LIMIT_PRICE = { code: "0025000001", message: "local: limit price is null" };
exports.TRADE_NO_INVEST = { code: "0025000002", message: "local: invest is null" };
exports.TRADE_DISABLE_INVEST_QUOTE_ON_LIMIT = { code: "0025000003", message: "local: only limit order enable invest quote" };
exports.TRADE_QTY_LOW_THAN_MIN = { code: "0025000004", message: "local: qty low than {min}", data: { min: "--" } };
exports.TRADE_QTY_HIGH_THAN_MAX = { code: "0025000005", message: "local: qty more than max" };
exports.TRADE_COST_LOW_THAN_MIN = { code: "0025000006", message: "local: cost low than {min}", data: { min: "--" } };
exports.TRADE_COST_HIGH_THAN_MAX = { code: "0025000007", message: "local: cost more than max" };
exports.TRADE_LIMIT_PRICE_HIGH = { code: "0025000008", message: "local: limit price too high" };
exports.TRADE_LIMIT_PRICE_LOW = { code: "0025000009", message: "local: limit price too low" };
exports.TRADE_NO_AVAILABLE = { code: "0025000010", message: "local: no available balance" };
exports.TRADE_AVAILABLE_NOT_ENOUGH = { code: "0025000011", message: "local: available balance not enough" };
exports.TRADE_INVEST_MORE_THAN_CAN_BUY = { code: "0025000012", message: "local: Invest more than can buy" };
exports.TRADE_DISABLE_OF_LIQUIDATION = {
    code: "0025000013",
    message: "local: Trade is disabled because account is in liquidating state",
};
exports.TRADE_LIMIT_POST_PRICE_HIGH = { code: "0025000014", message: "local: limit price need lower than current price" };
exports.TRADE_LIMIT_POST_PRICE_LOW = { code: "0025000015", message: "local: limit price need higher than current price" };
exports.TRADE_NO_LEVERAGE_ROW = { code: "0025000016", message: "local: 未获取到该杠杆倍数的杠杆配置信息" };
exports.TRADE_NOTIONAL_NEED_LOWER_LEVERAGE_ROW = { code: "0025000017", message: "local: 交易后仓位价值大于最大名义价值" };
exports.TRADE_TRIGGER_PRICE_NONE = { code: "0025000018", message: "local: 请输入触发价" };
exports.TRADE_SYMBOL_INFO_NONE = { code: "0025000019", message: "local: SymbolInfo is none" };
exports.TRADE_LEVERAGED_TOTAL_QUOTA = {
    code: "0025100001",
    message: "The amount of leverage token you bought exceeds the remaining quota, which is {quota}. Please reduce order quantity.",
    data: {
        quota: "--",
    },
};
exports.TRADE_LEVERAGED_ACCOUNT_LIMIT = {
    code: "0025100002",
    message: "The maximum manual holding amount of this leverage token is {quota}. Please reduce order quantity or switch to other leverage tokens.",
    data: {
        quota: "--",
    },
};
exports.TRADE_NOT_HAVE_LEVERAGED_CONFIG = {
    code: "0025100003",
    message: "没有找到该币种对应的杠杆配置信息",
    data: {
        quota: "--",
    },
};
exports.TRADE_CHANGED_LEVERAGED_LOW_MARGIN = {
    code: "0025100004",
    message: "可用保证金不足",
};
exports.TRADE_CHANGED_LEVERAGED_HIGH_POSITION_VALUE = {
    code: "0025100005",
    message: "当前仓位价值大于目标杠杆倍数所限制的最大仓位价值",
};
exports.TRADE_CHANGED_LEVERAGED_HAS_ACTIVE_ORDERS = {
    code: "0025100006",
    message: "当前币对存在全仓委托订单, 无法修改杠杆倍数, 请撤销委托订单后再修改",
};
